module.exports = __webpack_public_path__ + "img/banana.ece25c72.jpg";